import {AgentTopUpSideBarNav} from "./CHILDREN-SIDEBARNAV";

export function NPOSStaffMenuList(ammountInformation) {
    return {
        _name: "CSidebarNav",
        _children: [
          {
            _name: "CSidebarNavItem",
            name: "Dashboard",
            to: "/dashboard",
            icon: "cil-speedometer",
            badge: {
              color: "primary",
              text: "NEW"
            }
          },
          {
            _name: "CSidebarNavTitle",
            _children: ["Feature"]
          },
          {
            _name: "CSidebarNavDropdown",
            name: "Agent",
            route: "/agent",
            icon: "cil-chart-pie",
            items: [
              {
                name: "Follow Up",
                to: "/agent/follow-up",
                badge: {
                  color: "danger",
                  text: ammountInformation.follow_up
                }
              },
               AgentTopUpSideBarNav(ammountInformation.top_up),
              {
                name: "Listing" ,
                to: "/agent/listing",
                badge: {
                  color: "danger",
                  text: ammountInformation.listing,
                }
              },
              {
                name: "Location",
                to: "/agent/location"
              },
              {
                name: "Network",
                to: "/agent/network"
              },
              {
                name: "Report Performance",
                to: "/agent/performance"
              }
            ]
          },
          {
            _name: "CSidebarNavItem",
            name: "FAQ",
            to: "/management/faq",
            icon: "cil-cursor"
          },
           {
            _name: "CSidebarNavItem",
            name: "Member POS",
            to: "/management/member-pos",
            icon: "cil-layers"
          },  
          // info : disabled feature waiting follow up user for enabling
          // electronicDeliveryOrderSideBarNav,
        ]
      }
}